import React from 'react';
import { Link } from 'react-router-dom';
export const Logo = ({
  size = 'normal'
}) => {
  const sizeClasses = size === 'large' ? 'text-4xl' : 'text-2xl';
  return <Link to="/" className="flex items-center gap-2" data-id="element-149">
      <div className="flex items-center justify-center bg-primary rounded-lg p-2" data-id="element-150">
        <svg width={size === 'large' ? '40' : '28'} height={size === 'large' ? '40' : '28'} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-151">
          <path d="M12 3L20 7.5V16.5L12 21L4 16.5V7.5L12 3Z" fill="#F27D42" stroke="#ffffff" strokeWidth="1.5" data-id="element-152" />
          <path d="M12 8L16 10.5V15.5L12 18L8 15.5V10.5L12 8Z" fill="#ffffff" stroke="#F27D42" strokeWidth="1" data-id="element-153" />
          <path d="M4 7.5L12 12L20 7.5" stroke="#ffffff" strokeWidth="1.5" strokeLinecap="round" data-id="element-154" />
          <path d="M12 12V21" stroke="#ffffff" strokeWidth="1.5" strokeLinecap="round" data-id="element-155" />
        </svg>
      </div>
      <span className={`font-bold ${sizeClasses} text-primary`} data-id="element-156">Prismedge</span>
    </Link>;
};